import { api, apiDelete, apiPost, apiUpload } from "@/shared/api/http";

import type { WhitelistImportResult, WhitelistItem, WhitelistPage } from "./types";

export interface ListWhitelistParams {
  q?: string;
  limit?: number;
  offset?: number;
}

export const listWhitelist = (params: ListWhitelistParams = {}) => {
  const qs = new URLSearchParams();
  if (params.q) qs.set("q", params.q);
  qs.set("limit", String(params.limit ?? 100));
  qs.set("offset", String(params.offset ?? 0));
  return api<WhitelistPage>(`/api/admin/whitelist?${qs.toString()}`);
};

export const addWhitelist = (email: string, note?: string) =>
  apiPost<WhitelistItem>("/api/admin/whitelist", { email, note: note || null });

export const deleteWhitelist = (email: string) =>
  apiDelete<{ ok: boolean }>(
    `/api/admin/whitelist/${encodeURIComponent(email)}`,
  );

export const importWhitelist = (file: File) =>
  apiUpload<WhitelistImportResult>("/api/admin/whitelist/import", file);
